<template>
  <div class="dashboard">
    <MobileHeader @toggle-sidebar="toggleSidebar" />
    
    <Sidebar 
      :isOpen="sidebarOpen" 
      :isMobile="isMobile" 
      @close="closeSidebar"
    />

    <main class="main-content" :class="{ 'main-content-mobile': isMobile }">
      <header class="header" v-if="!isMobile">
        <h1>Табло</h1>
        <div class="header-info">
          <span>Добре дошли, {{ userEmail }}</span>
        </div>
      </header>
      
      <div class="content">
        <div class="stats-grid">
          <div class="stat-card">
            <div class="stat-icon">
              <i class="fas fa-users"></i>
            </div>
            <div class="stat-content">
              <h3>{{ totalUsers }}</h3>
              <p>Общо потребители</p>
            </div>
          </div>
          
          <div class="stat-card">
            <div class="stat-icon">
              <i class="fas fa-tags"></i>
            </div>
            <div class="stat-content">
              <h3>{{ totalCategories }}</h3>
              <p>Категории</p>
            </div>
          </div>
          
          <div class="stat-card">
            <div class="stat-icon">
              <i class="fas fa-comments"></i>
            </div>
            <div class="stat-content">
              <h3>{{ totalMessages }}</h3>
              <p>Съобщения</p>
            </div>
          </div>
          
          <div class="stat-card">
            <div class="stat-icon">
              <i class="fas fa-church"></i>
            </div>
            <div class="stat-content">
              <h3>{{ totalChurches }}</h3>
              <p>Църкви</p>
            </div>
          </div>
        </div>

        <!-- <div class="cards-grid">
          <div class="card">
            <div class="card-header">
              <h3>Последна активност</h3>
            </div>
            <div class="card-body">
              <div v-if="loading" class="loading">
                <i class="fas fa-spinner fa-spin"></i>
                Зареждане...
              </div>
              <div v-else-if="recentActivity.length === 0" class="no-data">
                <p>Няма скорошна активност</p>
              </div>
              <div v-else class="activity-list">
                <div v-for="activity in recentActivity" :key="activity.id" class="activity-item">
                  <div class="activity-icon">
                    <i :class="getActivityIcon(activity.type)"></i>
                  </div>
                  <div class="activity-content">
                    <p>{{ activity.description }}</p>
                    <small>{{ formatDate(activity.timestamp) }}</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </main>
  </div>
</template>

<script>
import { auth, database } from '../firebase'
import { ref as dbRef, onValue } from 'firebase/database'
import moment from 'moment'
import Sidebar from './Sidebar.vue'
import MobileHeader from './MobileHeader.vue'

export default {
  name: 'DashboardPage',
  components: {
    Sidebar,
    MobileHeader
  },
  data() {
    return {
      loading: true,
      users: {},
      categories: {},
      churches: {},
      recentActivity: [],
      sidebarOpen: false,
      isMobile: false
    }
  },
  computed: {
    userEmail() {
      return auth.currentUser?.email || ''
    },
    totalUsers() {
      return Object.keys(this.users).length
    },
    totalCategories() {
      return Object.keys(this.categories).length
    },
    totalMessages() {
      let count = 0
      Object.values(this.categories).forEach(category => {
        if (category.messages) {
          count += Object.keys(category.messages).length
        }
      })
      return count
    },
    totalChurches() {
      return Object.keys(this.churches).length
    }
  },
  methods: {
    toggleSidebar() {
      this.sidebarOpen = !this.sidebarOpen
    },
    closeSidebar() {
      this.sidebarOpen = false
    },
    checkMobile() {
      this.isMobile = window.innerWidth <= 768
      if (!this.isMobile) {
        this.sidebarOpen = false
      }
    },
    formatDate(timestamp) {
      return moment(timestamp).fromNow()
    },
    getActivityIcon(type) {
      switch (type) {
        case 'user_joined':
          return 'fas fa-user-plus'
        case 'message_posted':
          return 'fas fa-comment'
        case 'category_created':
          return 'fas fa-tag'
        default:
          return 'fas fa-circle'
      }
    },
    loadData() {
      // Load users
      const usersRef = dbRef(database, 'users')
      onValue(usersRef, (snapshot) => {
        this.users = snapshot.val() || {}
      })

      // Load categories
      const categoriesRef = dbRef(database, 'categories')
      onValue(categoriesRef, (snapshot) => {
        this.categories = snapshot.val() || {}
      })

      // Load churches
      const churchesRef = dbRef(database, 'churches')
      onValue(churchesRef, (snapshot) => {
        this.churches = snapshot.val() || {}
        this.loading = false
      })

      // Generate mock recent activity for demo
      setTimeout(() => {
        this.recentActivity = [
          {
            id: 1,
            type: 'user_joined',
            description: 'Нов потребител се регистрира',
            timestamp: Date.now() - 1000 * 60 * 30 // 30 minutes ago
          },
          {
            id: 2,
            type: 'message_posted',
            description: 'Ново съобщение в категория "Молитвени искания"',
            timestamp: Date.now() - 1000 * 60 * 60 * 2 // 2 hours ago
          },
          {
            id: 3,
            type: 'category_created',
            description: 'Създадена е нова категория "Неделно училище"',
            timestamp: Date.now() - 1000 * 60 * 60 * 24 // 1 day ago
          }
        ]
      }, 1000)
    }
  },
  mounted() {
    this.checkMobile()
    window.addEventListener('resize', this.checkMobile)
    this.loadData()
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkMobile)
  }
}
</script>

<style scoped>
.dashboard {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
}

.main-content {
  flex: 1;
  margin-left: 260px;
  background: #F8F8F8;
  transition: margin-left 0.3s ease;
}

.main-content-mobile {
  margin-left: 0 !important;
}

@media (max-width: 768px) {
  .main-content {
    margin-left: 0;
  }
}

.header {
  background: white;
  padding: 24px 32px;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header h1 {
  color: #333333;
  font-size: 28px;
  font-size: min(max(20px, 4vw), 28px);
  font-weight: 700;
}

.header-info {
  color: #6b7280;
  font-size: 14px;
}

.content {
  padding: 32px 16px;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 24px;
  margin-bottom: 32px;
}

.cards-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
}

.card {
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  padding: 0;
}

.card-header {
  padding: 20px 24px;
  border-bottom: 1px solid #e5e7eb;
  background: #F8F8F8;
}

.card-header h3 {
  color: #333333;
  font-size: 18px;
  font-weight: 600;
  margin: 0;
}

.card-body {
  padding: 20px 24px;
}

.stat-card {
  background: white;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  gap: 16px;
}

.stat-icon {
  width: 60px;
  height: 60px;
  border-radius: 12px;
  background: #1D687B;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 24px;
}

.stat-content h3 {
  font-size: 32px;
  font-weight: 700;
  color: #333333;
  margin-bottom: 4px;
}

.stat-content p {
  color: #6b7280;
  font-size: 14px;
  margin: 0;
}

.loading {
  text-align: center;
  padding: 40px 20px;
  color: #6b7280;
}

.loading i {
  font-size: 24px;
  margin-bottom: 12px;
  color: #1D687B;
}

.no-data {
  text-align: center;
  color: #6b7280;
  padding: 40px;
}

.activity-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.activity-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 0;
  border-bottom: 1px solid #f3f4f6;
}

.activity-item:last-child {
  border-bottom: none;
}

.activity-icon {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: rgba(121, 218, 242, 0.2);
  color: #1D687B;
  display: flex;
  align-items: center;
  justify-content: center;
}

.activity-content p {
  margin-bottom: 4px;
  color: #333333;
  font-size: 14px;
}

.activity-content small {
  color: #6b7280;
  font-size: 12px;
}

@media (max-width: 768px) {
  .main-content {
    margin-left: 0;
  }
  
  .stats-grid {
    grid-template-columns: 1fr;
  }
}
</style>
